import axios from 'axios';

export default function getLmiUser(lmiAuthcode) {
    const data = {
        AuthCode: lmiAuthcode,
        RedirectUri: undefined // gets populated in /server/handlers/api.js
    };
    return axios.post('/api/user/lmiuser', data);
}
